import { Pipe, PipeTransform } from '@angular/core';

@Pipe({name: 'splitCamelCase'})

export class SplitCamelCase implements PipeTransform {
  transform(value: string): string {
  	if (typeof value !== "string") {
    	  return value;
  	}
  	if(value == 'noveList'){
  		return 'NoveList'
  	}
  	var nameCapitalized = value.charAt(0).toUpperCase() + value.slice(1)
  	return nameCapitalized.split(/(?=[A-Z])/).join(' ');  
  }
}